import { StatusBadge } from '@/components/projects/StatusBadge'
import { getTestCaseStatusLabel } from '@/types'

export function TestCaseStatusBadge({ status }: { status: string }) {
  return <StatusBadge status={status} label={getTestCaseStatusLabel(status)} testIdPrefix="test-case" />
}
